module.exports = __webpack_public_path__ + "img/related-post-01.6c52c2f6.jpg";